<template>
    <div class="page-homes">
        <CBNavbar @navbar-click="onNavbarClick" />
        <div class="pages">
            <div class="pageContentOne">
                <div class="pageContentOne1">{{$t('value87')}}</div>
                 <div class="pageContentOne2">{{$t('FLOWPrice')}}：$0.1</div>
            </div>
            <img src="@/assets/images/background29.png" alt="background29" class="background29">
            <div class="TokenStaking1">{{$t('value88')}}</div> 
            <div class="TokenStaking2">1.{{$t('value89')}}</div>
            <div class="TokenStaking3">2.{{$t('value90')}}</div>
            <div class="underline"></div>
            <div v-if="!judge">
                <div class="TokenStaking4">
                    <div class="TokenStaking4_QuantityOfPledge">{{$t('value91')}}</div>
                    <div class="TokenStaking4_RevenueInformation" @click="judge=true">
                        <div class="TokenStaking4_RevenueInformation1">{{$t('value92')}}</div>
                        <img src="@/assets/images/EntryArrow1.png" alt="EntryArrow1" class="EntryArrow1">
                    </div>
                </div>
                <el-input class="input1" v-model="input" :placeholder="$t('value93')" :disabled="inputJudge"></el-input>
                <div class="submitInformation" v-if="!inputJudge" @click="tokenStakeFn">{{$t('value94')}}</div>
                <div class="TokenStaking5">{{$t('value95')}}：{{this.tokenFish!=='--'?Math.floor(this.tokenFish*100)/100:'--'}}</div>
            </div>
            <div v-if="judge">
                <div class="TokenStaking4">
                    <div class="TokenStaking4_QuantityOfPledge">{{$t('value79')}}</div>
                    <div class="TokenStaking4_RevenueInformation" @click="judge=false">
                        <div class="TokenStaking4_RevenueInformation1">{{$t('value94')}}</div>
                        <img src="@/assets/images/EntryArrow1.png" alt="EntryArrow1" class="EntryArrow1">
                    </div>
                </div>
                <div class="pageContentTens">
                    <div class="pageContentTen1">{{$t('value97')}}</div>
                    <div class="pageContentTen2">{{datas.TokenUserAmount}} FLOW</div>
                </div>
                <div class="pageContentEleven">
                    <div>{{$t('value98')}}</div>
                    <div>{{datas.TokenTotalStaked}} FLOW</div>
                </div>
                <div class="pageContentEleven">
                    <div>{{$t('value99')}}</div>
                    <div>{{datas.TokenDailyOutputAmount}} FLOW</div>
                </div>
                <div class="pageContentEleven">
                    <div>{{$t('value57')}}</div>
                    <div>{{datas.TokenPendingReward}} FLOW</div>
                </div>
                <div class="pageContentTwelve">
                    <div>{{$t('value58')}}</div>
                    <div>{{datas.TokenTotalClaimed}} FLOW</div>
                </div>
                <div class="pageContentFourteen">
                    <div class="pageContentFourteen1" @click="tokenWithdrawFn">{{$t('value102')}}</div>
                    <div class="pageContentFourteen2" @click="tokenClaimFn">{{$t('value103')}}</div>
                </div>
            </div>
            
        </div>
        <el-dialog
        :visible.sync="datas.dialogVisible"
        width="50%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="48vh">
        <span>{{$t('WaitForConfirmationOnTheChain')}}</span>
        </el-dialog>
    </div>
</template>

<script>
import CBNavbar from '@/components/navbar/indexTwo.vue'
import { mapState, mapGetters } from 'vuex'
import { Toast } from 'vant'
// import { MessageBox } from 'element-ui';
import './TokenStaking.css'
import { datas,ztai,setMyVariable,locationHrefIndex,tokenStake,tokenClaim,tokenWithdraw,ViewATokenBalance,isTokenAddress,approve,tokengetUserInfo} from "@/web3/index.js"
import Contract from 'web3-eth-contract'
import ERC20 from '../web3/ERC20.json'
export default {
    name: 'NFTPledge',
    components: {
        CBNavbar,
    },
    data() {
        return {
            input: '',
            inputJudge:false,
            judge:false,
            offTimer:null,
            Authorizationudgmentss:1,
            Authorizationudgmentsstwo:1,
            datas,
            tokenFish:'--',
        }
    },
    computed: {
        ...mapState(['address']),
        ...mapGetters(['isLogin']),
    },
    methods: {
      onNavbarClick(value) {
        console.log('Navbar clicked with value:', value); // 处理事件的方法，接收传递的值
        this.$router.push('/')
        // 在这里可以执行其他逻辑
      },
      upData(){
        setTimeout(async ()=>{
            console.log('打印地址',datas.FlowToken)
             this.tokenFish=await ViewATokenBalance(datas.FlowToken,this)
             tokengetUserInfo(this)
        },1500)
      },
      tokenClaimFn(){
        this.datas.dialogVisible=true
        tokenClaim(this)
      },
      tokenWithdrawFn(){
        this.datas.dialogVisible=true
        tokenWithdraw(datas.TokenUserAmount,this)
      },
      async tokenStakeFn(){
        let that=this
        let ERCContract;
        ERCContract =  new Contract(ERC20, datas.FlowToken); 
        console.log('过来了1');
        isTokenAddress(ERCContract,datas.FlowToken,datas.TokenStakingTokenAddress,this.input,this).then((res)=>{
            console.log('过来了2');
            if (res==false) {
                console.log(3);
                // 等待链上操作
                that.datas.dialogVisible=true
                approve(ERCContract,datas.FlowToken,datas.TokenStakingTokenAddress,this.input,that)
                this.Authorizationudgmentss=2
            }else{
                console.log('代币地址，数量',datas.FlowToken,this.input);
                // 等待链上确认
                that.datas.dialogVisible=true
                tokenStake(this.input,this)
                this.Authorizationudgmentsstwo=2
            }
        })
      }
    },
    watch: {
        address(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.upData();
            }
        }
    },
    mounted(){
        let that=this
        this.upData()
        this.clears=setInterval(()=>{
            that.showOverlay=that.$store.state.showOverlay
            //监听交易是否完成
            ztai().then((res)=>{
                if (res) {
                    console.log(33);
                    if (that.Authorizationudgmentsstwo==2) {
                        that.Authorizationudgmentsstwo=1
                    }else if(this.Authorizationudgmentss==2){
                        this.tokenStakeFn()
                        this.Authorizationudgmentss=1
                    }
                    Toast.clear();
                    that.datas.dialogVisible=false
                    this.upData()
                    that.drawer=false
                    let txHash=''
                    setMyVariable(txHash)
                }
            })
        },1000)
        this.offTimer=setInterval(async ()=>{
            let value=await locationHrefIndex()
            if(value){
            clearInterval(this.offTimer);  
            this.offTimer=null
            }
        },1000)
    },
    //离开页面时执行函数
    beforeDestroy() {         
        clearInterval(this.clears);  
        this.clears=null
        clearInterval(this.offTimer);  
        this.offTimer=null
    },
}
</script>
<style scoped lang="less">

</style>
